import styles from './JobWidgetHeader.module.css'
import { AutoSkeleton, useIsSkeleton } from '@/components/Skeleton'

interface JobWidgetHeaderProps {
  title: string
  subtitle?: string
  isSkeleton?: boolean
}

export function JobWidgetHeader({
  title,
  subtitle,
  isSkeleton,
}: JobWidgetHeaderProps) {
  isSkeleton = useIsSkeleton(isSkeleton)

  return (
    <AutoSkeleton isSkeleton={isSkeleton}>
      <div className={styles.header}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}
      </div>
    </AutoSkeleton>
  )
}
